/**
 * Presence Indicator - Shows user online/away/busy/offline status
 */

import React from 'react';
import { Badge } from 'antd';

interface PresenceIndicatorProps {
  status: 'online' | 'away' | 'busy' | 'offline';
  size?: 'small' | 'default' | 'large';
  children?: React.ReactNode;
}

/* CoreUI-aligned status colors */
const statusColors: Record<string, string> = {
  online: '#1b9e3e',  // cui-success
  away: '#f9b115',    // cui-warning
  busy: '#e55353',    // cui-danger
  offline: '#aab3c5', // cui-gray-500
};

export const PresenceIndicator: React.FC<PresenceIndicatorProps> = ({
  status,
  size = 'default',
  children,
}) => {
  const dotSize = size === 'small' ? 8 : size === 'large' ? 12 : 10;

  if (children) {
    return (
      <Badge
        dot
        color={statusColors[status]}
        style={{
          width: dotSize,
          height: dotSize,
        }}
      >
        {children}
      </Badge>
    );
  }

  return (
    <span
      style={{
        display: 'inline-block',
        width: dotSize,
        height: dotSize,
        borderRadius: '50%',
        backgroundColor: statusColors[status],
        marginRight: 4,
      }}
    />
  );
};






